export default __webpack_public_path__ + "static/media/video_icon.0cb6cba5.png";